import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer token from localStorage as fallback for cookie-less environments
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hw_session_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Iter47 — Multi-property: inject selected property_id so partner endpoints
  // scope to the right hotel in Chain mode. Single-hotel partners simply omit
  // this and the backend falls back to their first hotel.
  const pid = localStorage.getItem("ss_selected_property");
  if (pid && !config.headers["X-Property-Id"]) {
    config.headers["X-Property-Id"] = pid;
  }
  return config;
});

export default api;

export function wsUrlFor(threadId) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  const token = localStorage.getItem("hw_session_token") || "";
  return `${base}/api/ws/chat/${threadId}?token=${encodeURIComponent(token)}`;
}
